module.exports = __webpack_public_path__ + "static/Swiss721-MediumItalic-d274e0e4f046003cbb3e2c75b232962d.woff";